/* eslint-disable react/prop-types */
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CircleCheckBig, X } from "lucide-react";

const RoundedButton = ({ children, onClick }) => (
  <button
    onClick={onClick}
    className="relative px-6 py-2.5 overflow-hidden font-semibold text-black group"
  >
    {/* L-shaped border corners */}
    <div className="absolute inset-0 pointer-events-none">
      <div className="absolute top-0 left-0 w-4 h-full border-l-[3px] border-t-[3px] border-primary"></div>
      <div className="absolute top-0 right-0 w-4 h-4 border-r-[3px] border-t-[3px] border-primary"></div>
      <div className="absolute bottom-0 left-0 w-4 h-full border-b-[3px] border-l-[3px] border-primary"></div>
      <div className="absolute bottom-0 right-0 w-4 h-full border-b-[3px] border-r-[3px] border-primary"></div>
    </div>

    {/* Hover background effect */}
    <div className="absolute inset-0 group-hover:opacity-100 bg-primary transition-all scale-0 opacity-0 group-hover:scale-100 duration-500 ease-in-out origin-center"></div>

    {/* Button text */}
    <span className="relative z-10 transition-colors duration-500 ease-in-out group-hover:text-white">
      {children}
    </span>
  </button>
);

const LibraryAmbitionCommitment = ({ ambition, commitment }) => {
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState(null);

  const handleOpen = (type) => {
    setModalType(type);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setModalType(null);
  };

  const renderList = (items, key = "ambitions") => (
    <ul className="py-6 space-y-4 leading-loose text-gray-700">
      {items.map((item, index) => (
        <li key={index} className="flex flex-row items-start gap-3">
          <CircleCheckBig className="text-primary-500 mt-1" />
          <span>{item[key]}</span>
        </li>
      ))}
    </ul>
  );

  return (
    <div className="flex flex-col sm:flex-row gap-4 mt-8">
      <RoundedButton onClick={() => handleOpen("Ambition")}>
        {ambition?.title}
      </RoundedButton>
      <RoundedButton onClick={() => handleOpen("Commitment")}>
        {commitment?.title}
      </RoundedButton>

      {/* Modal with Framer Motion */}
      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleClose}
          >
            <motion.div
              className="bg-white rounded-2xl shadow-xl max-w-2xl w-full p-6 relative"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 50, opacity: 0 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={handleClose}
                className="absolute top-4 right-4 text-gray-500 hover:text-black"
              >
                <X size={24} />
              </button>

              <h2 className="text-2xl font-bold font-domine text-black mb-4">
                {modalType}
              </h2>

              {modalType === "Ambition" &&
                renderList(ambition?.ambitions, "ambitions")}
              {modalType === "Commitment" &&
                renderList(commitment?.commitments, "commitments")}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default LibraryAmbitionCommitment;
